import PageHandlersService from '@/utils/page-handlers-service';
import WaveSurfer from 'wavesurfer.js';
import { formatPlayerTime } from '../index/reviews-popups';

const pageHandlers = new PageHandlersService();

export let reviewsPagePlayingPlayer: any = null;

const init = () => {
    // Добавление попапов в разметку
    const popupsContainer = document.querySelector('.js-popups');
    const reviewElements = document.querySelectorAll<HTMLElement>('.js-review-item');

    reviewElements.forEach((reviewElement) => {
        const reviewPopup = reviewElement.querySelector('.js-review-popup')?.cloneNode(true);

        if (reviewPopup) {
            popupsContainer?.appendChild(reviewPopup);
        }
    });

    // Открытие / закрытие
    const popupElements = popupsContainer?.querySelectorAll<HTMLElement>('.js-review-popup');

    reviewElements.forEach((reviewElement) => {
        const reviewPopup = reviewElement.querySelector('.js-review-popup')?.cloneNode(true);
        const reviewId = reviewElement.dataset.id;

        if (reviewId && reviewPopup) {
            const popupElement = popupsContainer?.querySelector(`.js-review-popup[data-id="${reviewId}"]`);

            let removeBodyNoScrollTimeout: NodeJS.Timeout;

            const handleOpenPopup = () => {
                popupElements?.forEach((popupElement) => {
                    popupElement.classList.add('synchronized');
                    popupElement.classList.remove('active');
                });

                if (popupElement) {
                    popupElement.classList.add('active');
                }

                document.body.classList.add('no-scroll');

                if (removeBodyNoScrollTimeout) {
                    clearTimeout(removeBodyNoScrollTimeout);
                }

                if (reviewsPagePlayingPlayer && playingPlayerContainer) {
                    reviewsPagePlayingPlayer.pause();
                    playingPlayerContainer.classList.remove('playing');
                }
            };

            const handleClosePopup = () => {
                popupElements?.forEach((popupElement) => {
                    popupElement.classList.remove('synchronized');
                });

                if (popupElement) {
                    popupElement.classList.remove('active');
                }

                removeBodyNoScrollTimeout = setTimeout(() => {
                    document.body.classList.remove('no-scroll');
                }, 400);

                if (reviewsPagePlayingPlayer && playingPlayerContainer) {
                    reviewsPagePlayingPlayer.pause();
                    playingPlayerContainer.classList.remove('playing');

                    reviewsPagePlayingPlayer = null;
                }
            };

            pageHandlers.set(reviewElement, () => {
                if (popupElement) {
                    if (popupElement.classList.contains('active')) {
                        handleClosePopup();
                    } else {
                        handleOpenPopup();
                    }
                }
            });

            if (popupElement) {
                const closeButton = popupElement.querySelector('.js-reviews-popup-close');

                if (closeButton) {
                    pageHandlers.set(closeButton, handleClosePopup);
                }
            }

            pageHandlers.set('.js-menu-scroll-content', handleClosePopup);

            pageHandlers.set(reviewElement, (event) => event.stopPropagation());

            popupElements?.forEach((popupElement) => {
                pageHandlers.set(popupElement, (event) => event.stopPropagation());
            });
        }
    });

    // Аудио отзывы

    let playingPlayerContainer: Element | null = null;

    popupElements?.forEach((popupElement) => {
        if (!popupElement.classList.contains('js-audio-review')) {
            return;
        }

        const timelineContainer = popupElement.querySelector<HTMLElement>('.js-audio-review-item-timeline');
        const playButton = popupElement.querySelector<HTMLButtonElement>('.js-audio-review-item-play');
        const currentTimeElement = popupElement.querySelector<HTMLElement>('.js-audio-review-item-time-current');
        const durationTimeElement = popupElement.querySelector<HTMLElement>('.js-audio-review-item-time-duration');

        if (
            timelineContainer &&
            timelineContainer.dataset.audiofileSrc &&
            playButton &&
            currentTimeElement &&
            durationTimeElement
        ) {
            const player = WaveSurfer.create({
                container: timelineContainer,
                waveColor: '#D1D1D1',
                progressColor: '#E40088',
                barWidth: 2,
                barHeight: 1,
                height: 43 * 2,
                barGap: 1,
                cursorWidth: 0,
                mediaControls: true,
                hideScrollbar: true,
                normalize: true,
            });

            setTimeout(() => {
                player.load(timelineContainer.dataset.audiofileSrc);
            });

            pageHandlers.set(playButton, () => {
                player.playPause();
                popupElement.classList.toggle('playing');

                if (player.isPlaying()) {
                    if (reviewsPagePlayingPlayer && playingPlayerContainer) {
                        reviewsPagePlayingPlayer.pause();
                        playingPlayerContainer.classList.remove('playing');
                    }

                    reviewsPagePlayingPlayer = player;
                    playingPlayerContainer = popupElement;
                } else {
                    reviewsPagePlayingPlayer = null;
                }
            });

            pageHandlers.set(
                timelineContainer,
                () => {
                    setTimeout(() => {
                        currentTimeElement.innerText = formatPlayerTime(player.getCurrentTime());
                    }, 1);
                },
                'mouseup',
            );

            let isCurrentTimeSet = false;

            player.on('audioprocess', () => {
                if (!isCurrentTimeSet) {
                    isCurrentTimeSet = true;

                    currentTimeElement.innerText = formatPlayerTime(player.getCurrentTime());

                    setTimeout(() => {
                        isCurrentTimeSet = false;
                    }, 1000);
                }
            });

            player.on('ready', () => {
                durationTimeElement.innerText = formatPlayerTime(player.getDuration());
            });

            player.on('finish', () => {
                player.stop();
                popupElement.classList.remove('playing');
                reviewsPagePlayingPlayer = null;
            });
        }
    });
};

const destroy = () => {
    pageHandlers.clear();
};

const _module = { init, destroy };

export default _module;
